import React from 'react'

import BodyText from '../body-text/body-text.component'
import BodyRelativeTimestamp from '../body-relative-timestamp/body-relative-timestamp.component'
import BodyTimestamp from '../body-timestamp/body-timestamp.component'

const BodyItem = ({ item }) => {
  const { type = null } = item

  switch (type) {
  case 'relative-time':
    return <BodyRelativeTimestamp item={item} />
  case 'timestamp':
    return <BodyTimestamp item={item} />
  default:
    return <BodyText item={item} />
  }
}

export default BodyItem
